Vue.component('ow-icon', {

  owCSS: `.ow-svg{pointer-events:none;display:inline-block;width:24px;height:24px;fill:currentcolor;stroke:none}`,
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('i', {
      attrs: {
        "id": "icon"
      }
    }, [(_vm.iconPath.type !== 'html') ? _c('svg', {
      staticClass: "ow-svg",
      style: ({
        height: _vm.height + 'px',
        width: _vm.width + 'px',
        stroke: _vm.stroke,
        fill: _vm.fill
      }),
      attrs: {
        "viewbox": _vm.viewbox,
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('g', [_c('path', {
      attrs: {
        "d": _vm.iconPath.value
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.iconPath.type === 'html') ? _c('svg', {
      staticClass: "ow-svg",
      style: ({
        height: _vm.height + 'px',
        width: _vm.width + 'px',
        stroke: _vm.stroke,
        fill: _vm.fill
      }),
      attrs: {
        "viewbox": _vm.viewbox,
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('g', {
      domProps: {
        "innerHTML": _vm._s(_vm.iconPath.value)
      }
    })]) : _vm._e()])
  },
  staticRenderFns: [],

  name: 'owIcon',

  data: function data() {
    return {
      paths: {
        CANCEL: {
          type: 'string',
          value: 'M12 11.43l3.34-3.34.57.56L12.58 12l3.34 3.34-.56.57L12 12.58 8.66 15.9l-.57-.56L11.42 12 8.1 8.66l.56-.57L12 11.42zm9.5-2.53c.66 2 .66 4.2 0 6.2-.46 1.45-1.27 2.82-2.43 3.97-1.15 1.16-2.52 1.97-3.97 2.44-2 .66-4.2.66-6.2 0-1.45-.46-2.82-1.27-3.97-2.43-1.16-1.15-1.97-2.52-2.44-3.97-.66-2-.66-4.2 0-6.2.46-1.45 1.27-2.82 2.43-3.97C6.08 3.77 7.45 2.96 8.9 2.5c2-.66 4.2-.66 6.2 0 1.45.46 2.82 1.27 3.97 2.43 1.16 1.15 1.97 2.52 2.44 3.97zm-.75.25c-.45-1.37-1.2-2.62-2.24-3.66-1.03-1.04-2.28-1.8-3.65-2.25-1.85-.6-3.85-.6-5.7 0-1.37.45-2.62 1.2-3.66 2.24-1.05 1.03-1.8 2.28-2.25 3.65-.6 1.85-.6 3.85 0 5.7.45 1.37 1.2 2.62 2.24 3.66 1.03 1.05 2.28 1.8 3.65 2.25 1.85.6 3.85.6 5.7 0 1.37-.45 2.62-1.2 3.66-2.24 1.05-1.03 1.8-2.28 2.25-3.65.6-1.85.6-3.85 0-5.7z'
        },
        BACK: {
          type: 'string',
          value: 'M7.2 11.5h12.3v1H7.22l4.13 4.15-.7.7-5.36-5.37 5.35-5.33.7.7L7.2 11.5z'
        },
        EYE: {
          type: 'html',
          value: '<path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>'
        },
        KEY: {
          type: 'html',
          value: '<path fill="none" stroke="#000000" stroke-width=".72" d="M12.3824146,13.7892398 L12.3824146,17.9157782 L15.1966205,17.9157782 L15.1966205,19.7122532 C14.2196595,19.6892861 13.3593756,19.7352203 12.4053034,19.7122532 C12.4053034,20.5054583 12.3824146,21.2527291 12.4053034,22 C11.7303629,21.9770329 11.1961048,22 10.5909472,22 C10.5909472,21.9770329 10.5909472,14.7177501 10.613836,11.2166684 C10.613836,10.9836364 10.5909472,10.9136148 10.3347043,10.8435932 C7.21847781,10.0263007 5.98639042,6.33812117 7.94031243,3.79437526 C9.68488566,1.50662845 13.0115774,1.39067263 14.9186053,3.53725583 C16.2913751,5.10069886 16.361158,7.55145604 15.1050653,9.20900815 C14.4541302,10.0722348 13.5927297,10.6324079 12.5699911,10.9124944 C12.4521975,10.9124944 12.3824146,10.9825161 12.3824146,11.0766252 C12.4053034,12.5241124 12.3824146,12.836401 12.3824146,14.2838882 M9.5910974,4.58758033 C8.52146466,5.66087193 8.49745934,7.36547858 9.54420327,8.43877018 C10.5920637,9.48909468 12.336637,9.48909468 13.3833809,8.43877018 C14.4301248,7.38844567 14.4530136,5.63790483 13.4062697,4.58758033 C12.3824146,3.53725583 10.6378413,3.53725583 9.5910974,4.58758033 Z" transform="rotate(-135 11.5 12)" stroke-linecap="round" stroke-linejoin="round"></path>'
        },
        CROSS: {
          type: 'string',
          value: 'M12.57 11.86l5.66-5.65-.7-.7-5.67 5.66L6.2 5.5l-.7.7 5.66 5.66-5.66 5.66.7.7 5.66-5.65 5.66 5.66.7-.7-5.65-5.67z'
        },
        THICK_BACK: {
          type: 'string',
          value: 'M7.8 11l5.6-5.6L12 4l-8 8 8 8 1.4-1.4L7.8 13H20v-2z'
        },
        LOCATION: {
          type: 'string',
          value: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5z'
        },
        SWAP: {
          type: 'string',
          value: 'M13 22c5.52 0 10-4.48 10-10S18.52 2 13 2 3 6.48 3 12s4.48 10 10 10zm5.5-7L15 18.5 11.5 15H14v-4h2v4h2.5zm-11-6L11 5.5 14.5 9H12v4h-2V9H7.5z'
        },
        MALE: {
          type: 'html',
          value: '<g fill="none" fill-rule="evenodd"> <path d="M0 0h40v40H0z"/> <g transform="translate(3 6)"> <use fill="#FFF" xlink:href="#a"/> <rect width="26.772" height="28.617" x="3.5" y=".5" stroke="#979797" rx="5"/> </g> <g transform="translate(3 6)"> <use fill="#FFF" xlink:href="#b"/> <rect width="6" height="18" x=".5" y="5.5" stroke="#979797" rx="1"/> </g> <g transform="translate(3 6)"> <use fill="#FFF" xlink:href="#c"/> <rect width="6" height="18" x="27.5" y="5.5" stroke="#979797" rx="1"/> </g> <g transform="translate(3 6)"> <use fill="#FFF" xlink:href="#d"/> <rect width="13.764" height="4.332" x="10.5" y="23.5" stroke="#979797" rx="1"/> </g> </g>'
        },
        FEMALE: {
          type: 'html',
          value: '<g fill="none" fill-rule="evenodd"> <path d="M0 0h40v40H0z"/> <g transform="translate(3 4)"> <use fill="#FFF" xlink:href="#a"/> <rect width="26.772" height="28.617" x="3.5" y=".5" stroke="#979797" rx="5"/> </g> <g transform="translate(3 4)"> <use fill="#F3C7F0" xlink:href="#b"/> <rect width="6" height="18" x=".5" y="5.5" stroke="#979797" rx="1"/> </g> <g transform="translate(3 4)"> <use fill="#F3C7F0" xlink:href="#c"/> <rect width="6" height="18" x="27.5" y="5.5" stroke="#979797" rx="1"/> </g> <g transform="translate(3 4)"> <use fill="#F3C7F0" xlink:href="#d"/> <rect width="13.764" height="4.332" x="10.5" y="23.5" stroke="#979797" rx="1"/> </g> </g>'
        },
        USER: {
          type: 'html',
          value: '<g fill="none" fill-rule="evenodd"> <path fill="none" d="M0 0h23.213v23.233H0z"/> <g stroke="#777" stroke-width=".8" transform="translate(1 1)"> <circle cx="11" cy="11" r="10.6"/> <path d="M15.433 8.571c0-2.212-1.85-4.014-4.135-4.014-2.283 0-4.134 1.802-4.134 4.014 0 2.213 1.85 4.015 4.134 4.015 2.284 0 4.135-1.802 4.135-4.015zM3.486 18.232a10.569 10.569 0 0 0 7.75 3.368 10.57 10.57 0 0 0 7.822-3.445c-1.699-2.433-4.22-3.866-7.76-3.866-3.58 0-6.115 1.465-7.812 3.943z"/> </g> </g>'
        },
        GREEN_TICK: {
          type: 'html',
          value: '<g fill="none" fill-rule="evenodd"> <path d="M0 0h46v46H0z"/> <g transform="translate(4 4)"> <circle cx="19" cy="19" r="19" fill="#6DB043"/> <path fill="#FFF" d="M17.847 21.286l7.795-7.795 1.414 1.414-9.208 9.208-.55-.55-.001.001-4.837-4.837 1.414-1.414 3.973 3.973z"/> </g> </g>'
        },
        INFO: {
          type: 'html',
          value: '<g fill="none" fill-rule="evenodd"> <g transform="translate(-326 -9)"> <use fill="#F4FFE5" xlink:href="#a"/> <use fill="#000" filter="url(#b)" xlink:href="#a"/> </g> <path d="M0 0h20v20H0z"/> <path fill="#0076FF" d="M10 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm0-.727a7.273 7.273 0 1 0 0-14.546 7.273 7.273 0 0 0 0 14.546zM8.545 8.182h2.182V14h.728v.364h-2.91V14h.728V8.545h-.728v-.363zM9.818 7.09a.91.91 0 1 1 0-1.818.91.91 0 0 1 0 1.818z"/> </g>'
        },
        USER_PIC: {
          type: 'html',
          value: '<g fill="none" fill-rule="evenodd"> <path fill="#FFF" fill-opacity=".01" d="M0 0h24v24H0z"/> <g stroke="#777" stroke-width=".8"> <path d="M15.554 8.013c0-1.77-1.481-3.212-3.31-3.212s-3.31 1.442-3.31 3.212c0 1.77 1.481 3.212 3.31 3.212s3.31-1.442 3.31-3.212zM4.4 20.25h15.688v-2.74c0-1.968-4.348-3.747-7.844-3.747-3.495 0-7.844 1.779-7.844 3.747v2.74z"/> </g> </g>'
        },
        PHONE: {
          type: 'html',
          value: '<g fill="none" fill-rule="evenodd"> <path d="M0 0h24v24H0z"/> <g stroke="#777" stroke-width=".8"> <path d="M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99z"/> <path d="M17.4 19.4H6.6V4.6h10.8v14.8z"/> </g> </g>'
        },
        CLOCK: {
          type: 'html',
          value: '<g><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"></path></g>'
        },
        DOUBLE_UP: {
          type: 'html',
          value: '<g><polygon fill="#231F20" points="0.046,24.418 2.13,26.502 12.967,15.666 23.803,26.502 25.887,24.418 12.967,11.498  "/><polygon fill="#231F20" points="0.046,13.418 2.13,15.502 12.967,4.666 23.803,15.502 25.887,13.418 12.967,0.498  "/></g>'
        },
        CALENDAR: {
          type: 'html',
          value: '<g><path d="M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"></path></g>'
        }
      }
    };
  },

  props: {
    name: {
      type: String,
      required: true
    },
    viewbox: {
      type: String,
      required: false,
      default: '0 0 22 22'
    },
    height: {
      type: String,
      required: false
    },
    width: {
      type: String,
      required: false
    },
    stroke: {
      type: String,
      required: false
    },
    fill: {
      type: String,
      required: false
    }
  },

  computed: {
    iconPath: function iconPath() {
      return this.paths[this.name] || null;
    }
  }

});